'use client'
import React, { useContext, useEffect, useState } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { Select } from 'chakra-react-select';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import usePersonaApi from '@/persona/lib/usePersonaApi';
import { PersonaContext } from '../../lib/personaContext';
import { PersonaPageContext } from '../lib/personaPageContext';
import useExperienceApi from '../../../experiences/lib/useExperienceApi';

const MoveGroupInPersonaToGroupForm = forwardRef((props, ref) => {
  const {
    personaId,
  } = useContext(PersonaContext);
  const {
    experienceGroupList,
    group
  } = useContext(PersonaPageContext);
  const {
    groupId,
    hideSave,
    onSubmitted,
    onSubmitting,
    onValidityChange
  } = props;
  const {
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();
  const experienceApi = useExperienceApi();
  const [groupOptionsList, setGroupOptionsList] = useState(null);
  const [currentGroup, setCurrentGroup] = useState(null);

  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const targetGroupId = data.group.value;
      await experienceApi.moveGroupToGroupInPersona(
        groupId,
        targetGroupId
      );
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (experienceGroupList && groupId) {
      const currentGroupFiltered = experienceGroupList.filter(g => g.id === groupId);
      const newCurrentGroup = currentGroupFiltered[0];
      
      const groupOptionListInGroup = experienceGroupList
        .filter(eg => eg.id !== groupId && eg.group_id === group?.id && eg.id !== groupId)
        .map(eg => ({ label: eg.group?.name || eg.name, value: eg.id }));
      
      const otherGroupsOptionList = experienceGroupList
        .filter(eg => eg.id !== groupId && eg.group_id !== group?.id && eg.id !== groupId)
        .map(eg => ({ label: eg.group?.name || eg.name, value: eg.id }));
      
      setCurrentGroup(newCurrentGroup);
      setGroupOptionsList([{
        label: "In this group",
        options: groupOptionListInGroup,
      }, {
        label: "Other",
        options: otherGroupsOptionList
      }, {
        label: "Root",
        options: [{ label: "Root", value: null }]
      }]);
    }
  }, [experienceGroupList, groupId, group]);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid, onValidityChange]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="group"
          rules={{ required: "Please select a group" }}
          render={({
            field: { onBlur, value, onChange },
          }) => (
            <FormControl isInvalid={errors && errors.group}>
              <FormLabel>Select a Group</FormLabel>
              <Select
                options={groupOptionsList}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
              <FormErrorMessage>{errors && errors.group}</FormErrorMessage>
            </FormControl>
          )}
        />
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});

export default MoveGroupInPersonaToGroupForm; 